import { render, staticRenderFns } from "./TreeSubMenu.vue?vue&type=template&id=247944b6&scoped=true"
import script from "./TreeSubMenu.vue?vue&type=script&lang=js"
export * from "./TreeSubMenu.vue?vue&type=script&lang=js"
import style0 from "./TreeSubMenu.vue?vue&type=style&index=0&id=247944b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247944b6",
  null
  
)

export default component.exports